module.exports = __webpack_public_path__ + "media/images/mobile-view-320-3bff7d6bbe21e97f69a81533f407f4f8.svg";